/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import { Zap } from 'lucide-react';
import React from 'react';
import { AnalyticsFastestGoalRecord } from '../../domain/interfaces/tournament-analytics';

interface FastestGoalCardProps {
  record: AnalyticsFastestGoalRecord | null;
}

const Card = styled.div`
  background: ${({ theme }) => theme.colors.SurfaceWhite};
  border: 1px solid ${({ theme }) => theme.colors.SurfacePlatinum20};
  border-left: 4px solid ${({ theme }) => theme.colors.DarkYellow};
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.colors.DarkBlue};
  font-size: 14px;
  font-weight: 600;

  svg {
    color: ${({ theme }) => theme.colors.DarkYellow};
    flex-shrink: 0;
  }
`;

const EmptyState = styled.div`
  color: ${({ theme }) => theme.colors.Gray};
  font-size: 14px;
  text-align: center;
  padding: 12px 0;
`;

const PlayerName = styled.div`
  color: ${({ theme }) => theme.colors.DarkBlue};
  font-size: 20px;
  font-weight: 700;
  text-align: center;
`;

const Footer = styled.div`
  color: ${({ theme }) => theme.colors.WhiteGray};
  font-size: 12px;
  text-align: center;
`;

const FastestGoalCard = React.memo(({ record }: FastestGoalCardProps) => {
  return (
    <Card>
      <TitleRow>
        <Zap size={20} />
        <span>Самый быстрый гол</span>
      </TitleRow>
      {record === null ? (
        <EmptyState>Нет данных за выбранный период</EmptyState>
      ) : (
        <>
          <PlayerName>{record.playerName}</PlayerName>
          <Footer>
            {record.championshipName} · {format(new Date(record.matchDate), 'd MMM yyyy', { locale: ru })} · {record.goalSecond} сек.
          </Footer>
        </>
      )}
    </Card>
  );
});

export default FastestGoalCard;
